import { Dispatch } from 'redux';
import URLConstants from '../constants/url.constants';
import * as services from '../services/services';
import userSettingType from '../types/column.type';

export const addUserSetting = (data: any, userSettingKey: string) => {
	return (dispatch: Dispatch) => {
        let url = URLConstants.AddUserSettings;
		dispatch(addUserSettingStart());
		const userData = { key: userSettingKey, value: data }
		services.post(url, userData)
			.then(response => {
				dispatch(addUserSettingSuccess(response.data));
			})
			.catch(err => {
				dispatch(addUserSettingError(err));
			});
	};
};


export const getUserSetting = (userSettingKey: string) => {
	return (dispatch: Dispatch) => {
		dispatch(getUserSettingStart());
		let url = URLConstants.GetUserSettings + '/' + userSettingKey;
		services.get(url)
			.then(response => {
				dispatch(getUserSettingSuccess(response.data));
			})
			.catch(err => {
				dispatch(getUserSettingError(err));
			});
	};
};

export const getDataRange = (userSettingKey: string) => {
	return (dispatch: Dispatch) => {
		dispatch(getDataRangeStart());
		let url = URLConstants.GetUserSettings + '/' + userSettingKey;
		services.get(url)
			.then(response => {
				//if(response.data)
				 dispatch(getDataRangeSuccess(response.data));
			})
			.catch(err => {
				dispatch(getDataRangeError(err));
			});
	};
};


const addUserSettingStart = () => {
	return {
		type: userSettingType.ADD_USER_SETTING_START
	};
};

const addUserSettingSuccess = (data: any) => {
	return {
		type: userSettingType.ADD_USER_SETTING_SUCCESS,
		payload: data
	};
};

const addUserSettingError = (data: any) => {
	return {
		type: userSettingType.ADD_USER_SETTING_ERROR,
		payload: data
	};
};

const getUserSettingStart = () => {
	return {
		type: userSettingType.GET_USER_SETTING_START
	};
};

const getUserSettingSuccess = (data: any) => {
	return {
		type: userSettingType.GET_USER_SETTING_SUCCESS,
		payload: data
	};
};

const getUserSettingError = (data: any) => {
	return {
		type: userSettingType.GET_USER_SETTING_ERROR,
		payload: data
	};
};


const getDataRangeStart = () => {
	return {
		type: userSettingType.GET_DATA_RANGE_START
	};
};

const getDataRangeSuccess = (data: any) => {
	return {
		type: userSettingType.GET_DATA_RANGE_SUCCESS,
		payload: data
	};
};

const getDataRangeError = (data: any) => {
	return {
		type: userSettingType.GET_DATA_RANGE_ERROR,
		payload: data
	};
};

export const resetUserSettingState = () => {
	return (dispatch: Dispatch) => {
		dispatch(resetUserSettingStateDispatcher());
	};
};

export const resetDataRangeState = () => {
	return (dispatch: Dispatch) => {
		dispatch(resetDataRangeDispatcher());
	};
};
 

const resetUserSettingStateDispatcher = () => {
	return {
		type: userSettingType.RESET_USER_SETTING_STATE
	};
};

const resetDataRangeDispatcher = () => {
	return {
		type: userSettingType.RESET_DATA_RANGE_STATE
	};
};

 
export const resetUsersettingAddState = () => {
	return (dispatch: Dispatch) => {
		dispatch(resetUsersettingAddStateDispatcher());
	};
};

const resetUsersettingAddStateDispatcher = () => {
	return {
		type: userSettingType.RESET_USER_SETTING_ADD_STATE
	};
};



export const resetUserSettingSuccessState = () => {
	return (dispatch: Dispatch) => {
		dispatch(resetUserSettingSuccessStateDispatcher());
	};
};


const resetUserSettingSuccessStateDispatcher = () => {
	return {
		type: userSettingType.RESET_USER_SETTING_SUCCESS_STATE
	};
};